import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device/tree/";

export class RenameFolderCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "put";

    newFolderName: string = null;

    constructor(folderId, newFolderName) {
        super();
        this.endPoint += folderId;
        this.newFolderName = newFolderName;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand({ name: this.newFolderName });
        return new ApiGenericResponse(res);
    }
}
